// metadataSlice.ts

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type MetadataState = {
  elementsToFetch: string[];
  isFetching: boolean;
  regenerateEntireQueue: boolean;
  processingInformation: object;
};

const initialState: MetadataState = {
  elementsToFetch: [],
  isFetching: false,
  regenerateEntireQueue: false,
  processingInformation: {},
};

const metadataSlice = createSlice({
  name: "metadata",
  initialState,
  reducers: {
    initializeQueue: (state, action: PayloadAction<string[]>) => {
      state.elementsToFetch = action.payload;
    },
    dequeueElement: (state) => {
      const elementId = state.elementsToFetch[0];
      if (elementId && state.processingInformation[elementId]) {
        delete state.processingInformation[elementId];
      }
      state.elementsToFetch = state.elementsToFetch.slice(1);
    },
    setIsFetching: (state, action: PayloadAction<boolean>) => {
      state.isFetching = action.payload;
    },
    enqueueElements: (state, action: PayloadAction<string[]>) => {
      state.elementsToFetch = [...state.elementsToFetch, ...action.payload];
    },
    setRegenerateEntireQueue: (state, action: PayloadAction<boolean>) => {
      state.regenerateEntireQueue = action.payload;
    },
    markElementsWithForce: (state, action: PayloadAction<string[]>) => {
      action.payload?.forEach((elementId) => {
        if (state.processingInformation[elementId]) {
          state.processingInformation[elementId].force = true;
        } else {
          state.processingInformation[elementId] = { force: true };
        }
      });
    },
  },
});

export const {
  initializeQueue,
  dequeueElement,
  setIsFetching,
  enqueueElements,
  setRegenerateEntireQueue,
  markElementsWithForce,
} = metadataSlice.actions;

export default metadataSlice.reducer;
